import { n as P } from "./layout-BD1t4ofR.js";
import { n as l } from "./Logger-CmiOOsKC.js";
import { h as ye, t as we } from "./tracebehavior-5_qSKjs6.js";
import { n as h, r as J, t as ve } from "./bindingValues-BuN2Qy2j.js";
import { r as xe } from "./boxcollider-DfK5pGI3.js";
import { A as Q, C as Fe, D as Z, E as Re, M as je, O as q, S as $, T as Ue, a as Se, b as Le, d as Te, f as $e, h as ee, j as b, k as te, m as re, o as Me, u as se, v as Ae, w as Ce, x as ne } from "./measure-Dkg-XulW.js";
import { n as ke } from "./textBody-DYKq_GsW.js";
import { Matrix as oe } from "@babylonjs/core/Maths/math.vector.js";
import { MeshBuilder as Oe } from "@babylonjs/core/Meshes/meshBuilder.js";
import { Color4 as H } from "@babylonjs/core/Maths/math.color.js";
import { FontAsset as Ee } from "@babylonjs/addons/msdfText/fontAsset.js";
import { TextRenderer as We } from "@babylonjs/addons/msdfText/textRenderer.js";
var Pe = "" + new URL("./bungee-regular.json", import.meta.url).href, He = "" + new URL("./caveat-bold.json", import.meta.url).href, Ie = "" + new URL("./caveat-regular.json", import.meta.url).href, Be = "" + new URL("./inter-bold-italic.json", import.meta.url).href, Ne = "" + new URL("./inter-bold.json", import.meta.url).href, ze = "" + new URL("./inter-italic.json", import.meta.url).href, De = "" + new URL("./inter-regular.json", import.meta.url).href, Ye = "" + new URL("./jetbrains-mono-bold-italic.json", import.meta.url).href, Ke = "" + new URL("./jetbrains-mono-bold.json", import.meta.url).href, Ge = "" + new URL("./jetbrains-mono-italic.json", import.meta.url).href, Xe = "" + new URL("./jetbrains-mono-regular.json", import.meta.url).href, Ve = "" + new URL("./oswald-bold.json", import.meta.url).href, Je = "" + new URL("./oswald-regular.json", import.meta.url).href, Qe = "" + new URL("./roboto-bold-italic.json", import.meta.url).href, Ze = "" + new URL("./roboto-bold.json", import.meta.url).href, qe = "" + new URL("./roboto-italic.json", import.meta.url).href, et = "" + new URL("./roboto-regular.json", import.meta.url).href, tt = "" + new URL("./source-serif-4-bold-italic.json", import.meta.url).href, rt = "" + new URL("./source-serif-4-bold.json", import.meta.url).href, st = "" + new URL("./source-serif-4-italic.json", import.meta.url).href, nt = "" + new URL("./source-serif-4-regular.json", import.meta.url).href, ot = "" + new URL("./bungee-regular.png", import.meta.url).href, it = "" + new URL("./caveat-bold.png", import.meta.url).href, at = "" + new URL("./caveat-regular.png", import.meta.url).href, lt = "" + new URL("./inter-bold-italic.png", import.meta.url).href, ut = "" + new URL("./inter-bold.png", import.meta.url).href, ct = "" + new URL("./inter-italic.png", import.meta.url).href, dt = "" + new URL("./inter-regular.png", import.meta.url).href, ht = "" + new URL("./jetbrains-mono-bold-italic.png", import.meta.url).href, ft = "" + new URL("./jetbrains-mono-bold.png", import.meta.url).href, _t = "" + new URL("./jetbrains-mono-italic.png", import.meta.url).href, mt = "" + new URL("./jetbrains-mono-regular.png", import.meta.url).href, gt = "" + new URL("./oswald-bold.png", import.meta.url).href, pt = "" + new URL("./oswald-regular.png", import.meta.url).href, bt = "" + new URL("./roboto-bold-italic.png", import.meta.url).href, yt = "" + new URL("./roboto-bold.png", import.meta.url).href, wt = "" + new URL("./roboto-italic.png", import.meta.url).href, vt = "" + new URL("./roboto-regular.png", import.meta.url).href, xt = "" + new URL("./source-serif-4-bold-italic.png", import.meta.url).href, Ft = "" + new URL("./source-serif-4-bold.png", import.meta.url).href, Rt = "" + new URL("./source-serif-4-italic.png", import.meta.url).href, jt = "" + new URL("./source-serif-4-regular.png", import.meta.url).href, Ut = "" + new URL("./outlines/bungee-regular.json", import.meta.url).href, St = "" + new URL("./outlines/caveat-bold.json", import.meta.url).href, Lt = "" + new URL("./outlines/caveat-regular.json", import.meta.url).href, Tt = "" + new URL("./outlines/inter-bold-italic.json", import.meta.url).href, $t = "" + new URL("./outlines/inter-bold.json", import.meta.url).href, Mt = "" + new URL("./outlines/inter-italic.json", import.meta.url).href, At = "" + new URL("./outlines/inter-regular.json", import.meta.url).href, Ct = "" + new URL("./outlines/jetbrains-mono-bold-italic.json", import.meta.url).href, kt = "" + new URL("./outlines/jetbrains-mono-bold.json", import.meta.url).href, Ot = "" + new URL("./outlines/jetbrains-mono-italic.json", import.meta.url).href, Et = "" + new URL("./outlines/jetbrains-mono-regular.json", import.meta.url).href, Wt = "" + new URL("./outlines/oswald-bold.json", import.meta.url).href, Pt = "" + new URL("./outlines/oswald-regular.json", import.meta.url).href, Ht = "" + new URL("./outlines/roboto-bold-italic.json", import.meta.url).href, It = "" + new URL("./outlines/roboto-bold.json", import.meta.url).href, Bt = "" + new URL("./outlines/roboto-italic.json", import.meta.url).href, Nt = "" + new URL("./outlines/roboto-regular.json", import.meta.url).href, zt = "" + new URL("./outlines/source-serif-4-bold-italic.json", import.meta.url).href, Dt = "" + new URL("./outlines/source-serif-4-bold.json", import.meta.url).href, Yt = "" + new URL("./outlines/source-serif-4-italic.json", import.meta.url).href, Kt = "" + new URL("./outlines/source-serif-4-regular.json", import.meta.url).href, de = {
  Roboto: "roboto",
  Inter: "inter",
  "Source Serif 4": "source-serif-4",
  "JetBrains Mono": "jetbrains-mono",
  Oswald: "oswald",
  Bungee: "bungee",
  Caveat: "caveat"
}, Gt = Object.fromEntries(Object.entries(de).map(([e, t]) => [t, e])), Xt = [
  [
    "-bold-italic",
    "bold",
    "italic"
  ],
  [
    "-bold",
    "bold",
    "normal"
  ],
  [
    "-italic",
    "regular",
    "italic"
  ],
  [
    "-regular",
    "regular",
    "normal"
  ]
];
function G(e) {
  const t = e;
  return typeof t?.definitionUrl == "string" && t.definitionUrl.length > 0 && typeof t.textureUrl == "string" && t.textureUrl.length > 0 && (t.outlineUrl === void 0 || typeof t.outlineUrl == "string");
}
var Vt = /* @__PURE__ */ Object.assign({
  "../../assets/fonts/bungee-regular.json": Pe,
  "../../assets/fonts/caveat-bold.json": He,
  "../../assets/fonts/caveat-regular.json": Ie,
  "../../assets/fonts/inter-bold-italic.json": Be,
  "../../assets/fonts/inter-bold.json": Ne,
  "../../assets/fonts/inter-italic.json": ze,
  "../../assets/fonts/inter-regular.json": De,
  "../../assets/fonts/jetbrains-mono-bold-italic.json": Ye,
  "../../assets/fonts/jetbrains-mono-bold.json": Ke,
  "../../assets/fonts/jetbrains-mono-italic.json": Ge,
  "../../assets/fonts/jetbrains-mono-regular.json": Xe,
  "../../assets/fonts/oswald-bold.json": Ve,
  "../../assets/fonts/oswald-regular.json": Je,
  "../../assets/fonts/roboto-bold-italic.json": Qe,
  "../../assets/fonts/roboto-bold.json": Ze,
  "../../assets/fonts/roboto-italic.json": qe,
  "../../assets/fonts/roboto-regular.json": et,
  "../../assets/fonts/source-serif-4-bold-italic.json": tt,
  "../../assets/fonts/source-serif-4-bold.json": rt,
  "../../assets/fonts/source-serif-4-italic.json": st,
  "../../assets/fonts/source-serif-4-regular.json": nt
}), Jt = /* @__PURE__ */ Object.assign({
  "../../assets/fonts/bungee-regular.png": ot,
  "../../assets/fonts/caveat-bold.png": it,
  "../../assets/fonts/caveat-regular.png": at,
  "../../assets/fonts/inter-bold-italic.png": lt,
  "../../assets/fonts/inter-bold.png": ut,
  "../../assets/fonts/inter-italic.png": ct,
  "../../assets/fonts/inter-regular.png": dt,
  "../../assets/fonts/jetbrains-mono-bold-italic.png": ht,
  "../../assets/fonts/jetbrains-mono-bold.png": ft,
  "../../assets/fonts/jetbrains-mono-italic.png": _t,
  "../../assets/fonts/jetbrains-mono-regular.png": mt,
  "../../assets/fonts/oswald-bold.png": gt,
  "../../assets/fonts/oswald-regular.png": pt,
  "../../assets/fonts/roboto-bold-italic.png": bt,
  "../../assets/fonts/roboto-bold.png": yt,
  "../../assets/fonts/roboto-italic.png": wt,
  "../../assets/fonts/roboto-regular.png": vt,
  "../../assets/fonts/source-serif-4-bold-italic.png": xt,
  "../../assets/fonts/source-serif-4-bold.png": Ft,
  "../../assets/fonts/source-serif-4-italic.png": Rt,
  "../../assets/fonts/source-serif-4-regular.png": jt
}), Qt = /* @__PURE__ */ Object.assign({
  "../../assets/fonts/outlines/bungee-regular.json": Ut,
  "../../assets/fonts/outlines/caveat-bold.json": St,
  "../../assets/fonts/outlines/caveat-regular.json": Lt,
  "../../assets/fonts/outlines/inter-bold-italic.json": Tt,
  "../../assets/fonts/outlines/inter-bold.json": $t,
  "../../assets/fonts/outlines/inter-italic.json": Mt,
  "../../assets/fonts/outlines/inter-regular.json": At,
  "../../assets/fonts/outlines/jetbrains-mono-bold-italic.json": Ct,
  "../../assets/fonts/outlines/jetbrains-mono-bold.json": kt,
  "../../assets/fonts/outlines/jetbrains-mono-italic.json": Ot,
  "../../assets/fonts/outlines/jetbrains-mono-regular.json": Et,
  "../../assets/fonts/outlines/oswald-bold.json": Wt,
  "../../assets/fonts/outlines/oswald-regular.json": Pt,
  "../../assets/fonts/outlines/roboto-bold-italic.json": Ht,
  "../../assets/fonts/outlines/roboto-bold.json": It,
  "../../assets/fonts/outlines/roboto-italic.json": Bt,
  "../../assets/fonts/outlines/roboto-regular.json": Nt,
  "../../assets/fonts/outlines/source-serif-4-bold-italic.json": zt,
  "../../assets/fonts/outlines/source-serif-4-bold.json": Dt,
  "../../assets/fonts/outlines/source-serif-4-italic.json": Yt,
  "../../assets/fonts/outlines/source-serif-4-regular.json": Kt
}), U = nr(), O = new Map(U), F = /* @__PURE__ */ new Map();
function ie(e, t, r) {
  return je(O, {
    family: e,
    weight: t,
    style: r
  }, ir);
}
function S(e) {
  return b(e);
}
function zr() {
  return Object.keys(de);
}
function Zt(e, t) {
  const r = b(e);
  return U.has(r) || !G(t) ? !1 : (O.set(r, t), fe(e), F.delete(e.family), !0);
}
function qt(e) {
  const t = b(e);
  return U.has(t) ? !1 : (R.has(t) || F.delete(e.family), R.add(t), fe(e), !0);
}
function er(e) {
  let t = !1;
  for (const r of [...R]) {
    const s = E(r);
    s.family === e && (R.delete(r), O.has(r) || tr(s), t = !0);
  }
  return F.delete(e), t;
}
var R = /* @__PURE__ */ new Set();
function Dr(e) {
  for (const t of U.keys()) if (E(t).family === e) return !0;
  return !1;
}
function he(e) {
  return U.has(b(e));
}
function Yr(e) {
  return sr(e).length > 0;
}
var A = (() => {
  const e = /* @__PURE__ */ new Map();
  for (const t of O.keys()) {
    const { family: r, weight: s, style: n } = E(t), o = e.get(r) ?? [];
    o.push({
      weight: s,
      style: n
    }), e.set(r, o);
  }
  for (const t of e.values()) t.sort(_e);
  return e;
})();
function fe(e) {
  const t = A.get(e.family) ?? [];
  t.some((r) => r.weight === e.weight && r.style === e.style) || (t.push({
    weight: e.weight,
    style: e.style
  }), t.sort(_e), A.set(e.family, t));
}
function tr(e) {
  const t = A.get(e.family);
  if (!t) return;
  const r = t.findIndex((s) => s.weight === e.weight && s.style === e.style);
  r >= 0 && t.splice(r, 1);
}
var rr = [];
function _e(e, t) {
  const r = (o) => o === "regular" ? 0 : 1, s = (o) => o === "normal" ? 0 : 1, n = r(e.weight) - r(t.weight);
  return n !== 0 ? n : s(e.style) - s(t.style);
}
function sr(e) {
  return A.get(e) ?? rr;
}
function nr() {
  const e = /* @__PURE__ */ new Map();
  for (const [s, n] of Object.entries(Vt)) {
    const o = I(s), i = e.get(o) ?? {};
    i.definitionUrl = n, e.set(o, i);
  }
  for (const [s, n] of Object.entries(Jt)) {
    const o = I(s), i = e.get(o) ?? {};
    i.textureUrl = n, e.set(o, i);
  }
  const t = /* @__PURE__ */ new Map();
  for (const [s, n] of e) {
    if (!n.definitionUrl || !n.textureUrl) {
      l.warn(`[Text] Font "${s}" is missing a JSON or PNG file; skipping.`);
      continue;
    }
    const o = or(s);
    if (!o) continue;
    const i = Object.entries(Qt).find(([a]) => I(a) === s)?.[1];
    t.set(b(o), {
      definitionUrl: n.definitionUrl,
      textureUrl: n.textureUrl,
      outlineUrl: i
    });
  }
  const r = b({
    family: q,
    weight: Q,
    style: te
  });
  if (!t.has(r)) throw new Error(`[Text] Default font "${q} ${Q} ${te}" is required but not bundled. Expected file: src/assets/fonts/roboto-regular.{json,png}`);
  return t;
}
function I(e) {
  const t = e.lastIndexOf("/"), r = e.lastIndexOf(".");
  return e.slice(t + 1, r);
}
function or(e) {
  for (const [t, r, s] of Xt) {
    if (!e.endsWith(t)) continue;
    const n = Gt[e.slice(0, -t.length)];
    return n ? {
      family: n,
      weight: r,
      style: s
    } : null;
  }
  return null;
}
function E(e) {
  const t = e.lastIndexOf("|"), r = e.lastIndexOf("|", t - 1);
  return {
    family: e.slice(0, r),
    weight: e.slice(r + 1, t),
    style: e.slice(t + 1)
  };
}
var N = /* @__PURE__ */ new Set();
function Kr(e) {
  return N.add(e), () => {
    N.delete(e);
  };
}
function ir(e, t) {
  const r = E(e);
  let s = F.get(r.family);
  if (s || F.set(r.family, s = /* @__PURE__ */ new Set()), s.has(e)) return;
  s.add(e);
  const n = R.has(e);
  n ? l.debug(`[Text] Font "${r.family} ${r.weight} ${r.style}" is published but not loaded yet; drawing "${t.family} ${t.weight} ${t.style}" until it arrives.`) : l.warn(`[Text] Font "${r.family} ${r.weight} ${r.style}" is not available; falling back to "${t.family} ${t.weight} ${t.style}".`), ar({
    requested: r,
    drawn: t,
    reason: n ? "loading" : "unavailable"
  });
}
function ar(e) {
  for (const t of N) try {
    t(e);
  } catch (r) {
    l.warn(`[Text] font substitution listener threw: ${String(r)}`);
  }
}
var lr = 72, ur = 0.7;
function me(e) {
  const t = e.info?.padding?.[0], r = _(t) && t > 0 ? t : 0, s = Array.isArray(e.chars) ? e.chars.find((o) => o?.id === lr) : void 0;
  if (s && _(s.yoffset) && _(s.height) && s.height > 0) return s.yoffset + r;
  const n = e.common?.base;
  return _(n) && n > 0 ? n * (1 - ur) : 0;
}
function cr(e, t) {
  const r = new Array(95).fill(-1), s = [], n = /* @__PURE__ */ new Set();
  for (const o of t) {
    if (n.has(o.id)) throw new Error(`[font metrics] ${e}: glyph ${o.id} appears twice`);
    n.add(o.id), o.id >= 32 && o.id <= 126 ? r[o.id - 32] = o.xadvance : s.push([o.id, o.xadvance]);
  }
  return s.sort((o, i) => o[0] - i[0]), {
    advances: r,
    extraAdvances: s
  };
}
function dr(e, t = "BMFont definition") {
  const { advances: r, extraAdvances: s } = cr(t, e.chars), n = [];
  for (const o of e.kernings ?? [])
    o.amount !== 0 && n.push(o.first, o.second, o.amount);
  return {
    emSize: e.info.size,
    commonLineHeight: e.common.lineHeight,
    capTop: me(e),
    advances: r,
    extraAdvances: s.flat(),
    kernings: n
  };
}
function hr(e) {
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return null;
  }
  if (typeof t != "object" || t === null) return null;
  const r = t;
  return !_(r.info?.size) || !(r.info.size > 0) || !_(r.common?.lineHeight) || !Array.isArray(r.chars) || r.chars.length === 0 || !r.chars.every(fr) || r.kernings !== void 0 && !(Array.isArray(r.kernings) && r.kernings.every(_r)) ? null : r;
}
function _(e) {
  return typeof e == "number" && Number.isFinite(e);
}
function fr(e) {
  const t = e;
  return Number.isInteger(t?.id) && _(t?.xadvance);
}
function _r(e) {
  const t = e;
  return Number.isInteger(t?.first) && Number.isInteger(t?.second) && _(t?.amount);
}
var ae = Object.keys({
  regular: !0,
  bold: !0
}), le = Object.keys({
  normal: !0,
  italic: !0
}), z = /* @__PURE__ */ new Set(), M = /* @__PURE__ */ new Map(), X = /* @__PURE__ */ new Set(), j = /* @__PURE__ */ new Map();
function D(e, t) {
  return X.has(e) ? t === void 0 || j.get(e) === t : !1;
}
function mr(e) {
  return z.add(e), () => {
    z.delete(e);
  };
}
function gr(e, t, r, s) {
  const n = L(e, t), o = S(n), i = Re(o, dr(r));
  if (!i) return !1;
  if (!Zt(n, {
    definitionUrl: t.definitionUrl,
    textureUrl: t.textureUrl
  }))
    return i(), !1;
  X.add(o), s !== void 0 ? j.set(o, s) : j.delete(o);
  for (const a of z) try {
    a(e, n);
  } catch (u) {
    l.warn(`[Text] font registry listener threw: ${String(u)}`);
  }
  return !0;
}
async function pr(e, t, r) {
  const s = L(e, t), n = S(s);
  if (he(s) || D(n, r)) return !1;
  if (!G(t))
    return l.warn(`[Text] hosted font "${e}" has a face without a definitionUrl or textureUrl`), !1;
  const o = M.get(n);
  if (o && o.revision === r) return o.promise;
  const i = () => D(n, r) ? Promise.resolve(!1) : wr(e, t, r), a = o ? o.promise.then(i) : i();
  return M.set(n, {
    revision: r,
    promise: a
  }), a.then(() => {
    M.get(n)?.promise === a && M.delete(n);
  }), a;
}
var ue = 2e4;
async function Y(e, t) {
  const r = new AbortController();
  let s;
  const n = new Promise((o, i) => {
    s = setTimeout(() => {
      r.abort(), i(/* @__PURE__ */ new Error(`no answer within ${ue / 1e3}s`));
    }, ue);
  });
  try {
    return await Promise.race([fetch(e, { signal: r.signal }).then(t), n]);
  } finally {
    clearTimeout(s);
  }
}
function br(e) {
  return e.ok ? e.text().then((t) => ({
    status: e.status,
    text: t
  })) : Promise.resolve({
    status: e.status,
    text: null
  });
}
function yr(e) {
  return e.body?.cancel().catch(() => {
  }), Promise.resolve(e.status);
}
async function wr(e, t, r) {
  try {
    const [s, n] = await Promise.all([Y(t.definitionUrl, br), Y(t.textureUrl, yr)]);
    if (s.text === null)
      return l.warn(`[Text] hosted font "${e}" definition fetch failed (${s.status}): ${t.definitionUrl}`), !1;
    if (n < 200 || n >= 300)
      return l.warn(`[Text] hosted font "${e}" atlas fetch failed (${n}): ${t.textureUrl}`), !1;
    const o = hr(s.text);
    return o ? gr(e, t, o, r) : (l.warn(`[Text] hosted font "${e}" definition is not a usable BMFont document: ${t.definitionUrl}`), !1);
  } catch (s) {
    return l.warn(`[Text] hosted font "${e}" failed to load: ${String(s)}`), !1;
  }
}
async function ge(e) {
  const t = {
    family: e.family,
    registered: [],
    skipped: []
  };
  e.charset && l.debug(`[Text] hosted font "${e.family}" charset: ${e.charset}`);
  const r = e.faces.map((n) => {
    const o = L(e.family, n);
    return {
      face: n,
      key: o,
      wasCurrent: D(S(o), e.revision)
    };
  }), s = await Promise.all(r.map(async (n) => ({
    ...n,
    ok: await pr(e.family, n.face, e.revision)
  })));
  for (const { key: n, ok: o, wasCurrent: i } of s) o ? t.registered.push(n) : t.skipped.push({
    key: n,
    reason: vr(n, i)
  });
  return t;
}
function vr(e, t) {
  return t ? "already-registered" : he(e) ? "bundled" : "fetch-failed";
}
function L(e, t) {
  return {
    family: e,
    weight: t.weight ?? "regular",
    style: t.style ?? "normal"
  };
}
async function Gr(e) {
  try {
    const t = await Y(e, async (o) => ({
      status: o.status,
      body: o.ok ? await o.json() : void 0,
      ok: o.ok
    }));
    if (!t.ok)
      return l.warn(`[Text] font pack fetch failed (${t.status}): ${e}`), null;
    const r = t.body;
    if (typeof r?.family != "string" || !Array.isArray(r.faces))
      return l.warn(`[Text] font pack at ${e} is missing "family" or "faces"`), null;
    const s = r.faces.findIndex((o) => !G(o));
    if (s !== -1)
      return l.warn(`[Text] font pack at ${e}: face ${s} is missing "definitionUrl" or "textureUrl"`), null;
    const n = r.faces.findIndex((o) => o.weight !== void 0 && !ae.includes(o.weight) || o.style !== void 0 && !le.includes(o.style));
    return n !== -1 ? (l.warn(`[Text] font pack at ${e}: face ${n} has a weight or style outside ${ae.join("/")} and ${le.join("/")}`), null) : await ge(r);
  } catch (t) {
    return l.warn(`[Text] font pack at ${e} failed to load: ${String(t)}`), null;
  }
}
function Xr(e) {
  return j.get(S(e));
}
var y = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), xr = Promise.resolve(null), w = /* @__PURE__ */ new Map(), pe = /* @__PURE__ */ new WeakSet();
function Vr(e) {
  for (const t of e) {
    const r = y.get(t.family);
    y.set(t.family, t);
    for (const s of t.faces) qt(L(t.family, s));
    Fr(r, t) && be(t.family);
  }
}
function Fr(e, t) {
  return t.revision === void 0 ? !1 : t.faces.some((r) => {
    const s = S(L(t.family, r));
    return X.has(s) && j.get(s) !== t.revision;
  }) || g.has(t.family) && e?.revision !== t.revision;
}
function be(e) {
  return g.delete(e), w.delete(e), C(e);
}
function Jr(e) {
  const t = y.delete(e);
  return g.delete(e), w.delete(e), er(e) || t;
}
function Qr() {
  return [...y.keys()].sort();
}
function Zr(e) {
  return y.get(e);
}
function C(e) {
  const t = g.get(e);
  if (t) return t;
  const r = y.get(e);
  if (!r) return xr;
  const s = ge(r).then((n) => {
    if (pe.add(s), g.get(e) !== s) return n;
    const o = n.skipped.filter((a) => a.reason === "fetch-failed");
    if (o.length === 0)
      return w.delete(e), n;
    const i = {
      family: e,
      failed: o
    };
    w.set(e, i), l.warn(`[Text] hosted font "${e}": ${o.length} of ${r.faces.length} face(s) did not load. Retry with retryFontFamily(${JSON.stringify(e)}).`);
    for (const a of K) try {
      a(i);
    } catch (u) {
      l.warn(`[Text] hosted font failure listener threw: ${String(u)}`);
    }
    return n;
  });
  return g.set(e, s), s;
}
function Rr(e) {
  const t = g.get(e);
  return t !== void 0 && !pe.has(t);
}
function qr(e) {
  return w.has(e) ? be(e) : C(e);
}
var K = /* @__PURE__ */ new Set();
function es(e) {
  return K.add(e), () => {
    K.delete(e);
  };
}
function ts() {
  return [...w.values()].map((e) => ({
    family: e.family,
    failed: e.failed.map((t) => ({
      key: { ...t.key },
      reason: t.reason
    }))
  }));
}
var k = /* @__PURE__ */ new WeakMap(), jr = [];
function Ur(e, t) {
  let r = k.get(e);
  r || (r = /* @__PURE__ */ new Set(), k.set(e, r)), r.add(t);
}
function Sr(e, t) {
  k.get(e)?.delete(t);
}
function rs(e) {
  const t = k.get(e);
  return t && t.size > 0 ? Array.from(t) : jr;
}
var f = "Roboto", v = "regular", x = "normal", Lr = 5e-4;
function d(e, t) {
  const r = typeof e == "number" ? e : Number(e);
  return Number.isFinite(r) ? r : t;
}
function B(e) {
  return typeof e == "number" && Number.isFinite(e) ? Math.min(1, Math.max(0, e)) : 1;
}
var Tr = [
  "text",
  "fontSize",
  "anchorX",
  "anchorY",
  "lineHeight",
  "letterSpacing",
  "wrap"
], ss = class extends we {
  static behaviorType = "Text";
  fontAsset = null;
  textRenderer = null;
  _strokeAlpha = 1;
  renderObserver = null;
  _selectionMesh = null;
  _metrics = {
    emSize: 80,
    distanceRange: 4,
    naturalLineHeightEm: 1.325,
    capTop: 27
  };
  _loadedFontKey;
  _drawnFace;
  _appliedParagraph = null;
  _loadGeneration = 0;
  _pendingLoads = 0;
  _hostFade = 1;
  _layoutMeasure = null;
  _layoutWrapWidth = null;
  _layoutSlotWidth = null;
  _measureCache = null;
  _onFontRegistered = (e) => {
    if (this._detached) return;
    const t = this._resolved;
    (h(t.fontFamily) ? t.fontFamily : f) === e && this._currentFace() !== this._drawnFace && (this._measureCache = null, this._publishMeasurement(), (this._loadGeneration > 0 || this.textRenderer) && this.load());
  };
  _fontRegistryUnsubscribe = null;
  _body = null;
  _bodyKey = null;
  _bodyFailed = !1;
  constructor(e, t) {
    super(e, t), this._loadedFontKey = ce(t), this._listenForFonts();
  }
  _listenForFonts() {
    const e = this.sceneObject.transform;
    if (e.isDisposed()) return;
    const t = mr(this._onFontRegistered), r = e.onDisposeObservable.add(() => this._stopListeningForFonts());
    this._fontRegistryUnsubscribe = () => {
      t(), e.onDisposeObservable.remove(r);
    };
  }
  _stopListeningForFonts() {
    this._fontRegistryUnsubscribe?.(), this._fontRegistryUnsubscribe = null;
  }
  _loadChain = Promise.resolve();
  _detached = !1;
  async load() {
    this._pendingLoads++;
    const e = ++this._loadGeneration;
    return this._loadChain = this._loadChain.catch((t) => {
      l.warn(`[Text] previous load failed: ${String(t)}`);
    }).then(async () => {
      try {
        await this.createTextRenderer(e);
      } finally {
        this._pendingLoads--;
      }
      this._bodyFailed && (this._bodyKey = null), this._refreshBody();
    }), this._loadChain;
  }
  isFontSettled() {
    if (this._detached) return !0;
    if (this._pendingLoads > 0) return !1;
    const e = this._resolved;
    return Rr(h(e.fontFamily) ? e.fontFamily : f) ? !1 : this._loadGeneration === 0 && !this.textRenderer ? !0 : this._currentFace() === this._drawnFace;
  }
  setHostFade(e) {
    const t = Number.isFinite(e) ? Math.min(1, Math.max(0, e)) : 1;
    t !== this._hostFade && (this._hostFade = t, this.textRenderer && this.applyTextProperties());
  }
  init() {
  }
  onAttach(e) {
    P(this.sceneObject);
    const t = this._getParentNode();
    this.textRenderer && (this.textRenderer.parent = t), this._body?.setParent(t), this._placeSelectionMesh();
  }
  onDetach() {
    this._detached = !0, this._stopListeningForFonts(), this.disposeTextRenderer(), this._body?.dispose(), this._body = null, this._bodyKey = null, P(this.sceneObject);
  }
  onAnimationRootCreated(e) {
    this.textRenderer && (this.textRenderer.parent = e), this._selectionMesh && (this._selectionMesh.parent = e), this._body?.setParent(e);
  }
  async createTextRenderer(e) {
    const t = () => e !== this._loadGeneration || this._detached;
    if (t()) return;
    const r = this._resolved, s = h(r.fontFamily) ? r.fontFamily : f, n = r.fontWeight ?? v, o = r.fontStyle ?? x;
    C(s);
    const { definitionUrl: i, textureUrl: a } = ie(s, n, o);
    this._drawnFace = Z(s, n, o);
    try {
      const u = await fetch(i);
      if (t()) return;
      if (!u.ok) throw new Error(`Failed to fetch font definition: ${u.status}`);
      const p = await u.text();
      if (t()) return;
      const c = new Ee(p, a, this.scene), W = this.scene.getEngine(), T = await We.CreateTextRendererAsync(c, W);
      if (this.textRenderer && !t() && await this._whenAtlasReady(c, t), t()) {
        T.dispose(), c.dispose();
        return;
      }
      this._releaseRenderer(), this.fontAsset = c, this.textRenderer = T, this._strokeAlpha = 1, this._extractFontMetrics(), this.applyTextProperties();
      const m = this._getParentNode();
      m && (this.textRenderer.parent = m), this.updateTextContent(), this.renderObserver = this.scene.onAfterCameraRenderObservable.add((V) => {
        this.renderGlyphs(V.getViewMatrix(), V.getProjectionMatrix());
      }), Ur(this.scene, this), l.debug(`[Text] Created text renderer for ${this.sceneObject.name}`);
    } catch (u) {
      l.warn(`[Text] Failed to create text renderer: ${String(u)}`);
    }
  }
  _extractFontMetrics() {
    if (!this.fontAsset) return;
    const e = this.fontAsset._font, t = e.info.size;
    this._metrics = {
      emSize: t,
      distanceRange: e.distanceField?.distanceRange ?? 4,
      naturalLineHeightEm: e.common?.lineHeight && t > 0 ? e.common.lineHeight / t : this._metrics.naturalLineHeightEm,
      capTop: me(e)
    };
  }
  _getCommonLineHeightFontUnits() {
    return (this.fontAsset ? this.fontAsset._font : void 0)?.common?.lineHeight ?? this._metrics.emSize;
  }
  _fillColor() {
    const e = this._resolved, t = J(e.color, "Text.color") ?? "#FFFFFF", r = H.FromHexString(t.length === 7 ? t + "FF" : t);
    return r.a *= B(e.opacity), r;
  }
  applyTextProperties() {
    if (!this.textRenderer) return;
    const e = this._resolved, t = B(e.opacity) * this._hostFade, r = this._fillColor();
    r.a *= this._hostFade, this.textRenderer.color = r, this._body?.setColor(this._bodyColor());
    const s = J(e.strokeColor, "Text.strokeColor");
    if (s && e.strokeWidth && e.strokeWidth > 0) {
      const n = H.FromHexString(s.length === 7 ? s + "FF" : s);
      this._strokeAlpha = n.a, n.a *= t, this.textRenderer.strokeColor = n, this.textRenderer.strokeOutsetWidth = Ue(e.strokeWidth, this._metrics);
    } else
      this.textRenderer.strokeOutsetWidth = 0, this.textRenderer.strokeColor.a = this._strokeAlpha * t;
  }
  updateTextContent() {
    if (!this.textRenderer || !this.fontAsset) return;
    const e = this._resolved, t = e.text ?? "Text", r = typeof t == "string" ? t : String(t), { scale: s, anchorY: n, rendererLineHeight: o, layoutParams: i } = this._deriveParagraphParams();
    {
      const m = this.textRenderer;
      m._charMatrices?.length && (m._charMatrices.length = 0, m._charUvs.length = 0, m._isDirty = !0);
    }
    const a = ee(r, i, this._fontApi()), u = {
      lineHeight: o,
      letterSpacing: i.letterSpacingUnits,
      customLayoutEngine: () => ({
        paragraph: a.text,
        lines: a.lines,
        glyphs: a.glyphs,
        width: a.width,
        height: a.height
      })
    }, p = re(a, n, this._metrics.capTop), c = 1 / this._metrics.emSize, W = ne(n, p.yTop * c, p.yBot * c, s), T = oe.Scaling(s, s, s).multiply(oe.Translation(0, W, 0));
    this.textRenderer.addParagraph(r, u, T), this._appliedParagraph = {
      text: e.text,
      fontSize: e.fontSize,
      anchorX: e.anchorX,
      anchorY: e.anchorY,
      lineHeight: e.lineHeight,
      letterSpacing: e.letterSpacing,
      wrap: e.wrap
    }, this._placeSelectionMesh(), this._publishMeasurement(), this._refreshBody();
  }
  _resolveFace() {
    const e = this._resolved;
    return C(h(e.fontFamily) ? e.fontFamily : f), this._drawnFace = this._currentFace(), this._drawnFace;
  }
  _currentFace() {
    const e = this._resolved;
    return Z(h(e.fontFamily) ? e.fontFamily : f, e.fontWeight ?? v, e.fontStyle ?? x);
  }
  _measureContentBox(e) {
    const t = this._resolveFace(), r = this._measureInput(e), s = se(r), n = this._measureCache;
    if (n && n.key === s) return n.box;
    const o = Me(r, t);
    return this._measureCache = {
      key: s,
      box: o
    }, o;
  }
  _measureInput(e) {
    const t = this._resolved, r = t.text ?? "Text";
    return {
      text: typeof r == "string" ? r : String(r),
      fontSize: d(t.fontSize, 14),
      lineHeight: d(t.lineHeight, 1.2),
      letterSpacing: d(t.letterSpacing, 0),
      anchorX: t.anchorX ?? "center",
      anchorY: t.anchorY ?? "middle",
      fontFamily: h(t.fontFamily) ? t.fontFamily : f,
      fontWeight: t.fontWeight ?? v,
      fontStyle: t.fontStyle ?? x,
      wrap: t.wrap,
      wrapWidth: e !== void 0 ? e : this._layoutWrapWidth,
      slotWidth: e !== void 0 ? void 0 : this._layoutSlotWidth
    };
  }
  _bodyInput() {
    const e = this._depthEm();
    if (e <= 0) return {
      key: "",
      input: null
    };
    const t = this._outlineUrl();
    if (!t || this._srcIsBody()) return {
      key: "",
      input: null
    };
    const r = this._measureInput(), s = this._strokeEm(), n = `${t}|${e}|${s}|${se({
      ...r,
      slotWidth: void 0,
      wrapWidth: r.wrap === !1 ? null : r.wrapWidth
    })}`;
    if (n === this._bodyKey) return {
      key: n,
      input: null
    };
    const o = this._currentFace(), { layout: i, scale: a, unitScale: u, yWorldOffset: p } = Se(r, o);
    return {
      key: n,
      input: {
        outlineUrl: t,
        glyphs: i.glyphs.map((c) => ({
          code: c.char.id,
          x: c.x,
          y: c.y
        })),
        frame: {
          unitScale: u,
          yOffset: p,
          depth: e * a,
          inset: this._bodyInset(a),
          outset: s * o.emSize
        }
      }
    };
  }
  _strokeEm() {
    const e = this._resolved, t = d(e.strokeWidth, 0);
    return t <= 0 || !this._strokeHex() ? 0 : Math.min(t, this._metrics.distanceRange / (2 * this._metrics.emSize));
  }
  _strokeHex() {
    const e = this._resolved.strokeColor;
    return h(e) && ve.test(e) ? e : null;
  }
  _bodyColor() {
    const e = this._strokeEm() > 0 ? this._strokeHex() : null;
    if (!e) return this._fillColor();
    const t = H.FromHexString(e.length === 7 ? e + "FF" : e);
    return t.a *= B(this._resolved.opacity), t;
  }
  _depthEm() {
    return Math.min(1, Math.max(0, d(this._resolved.depth, 0)));
  }
  _srcIsBody() {
    const e = this.sceneObject.getBehavior("Provenance")?.getData();
    return ye(this.sceneObject.src, e ? [e] : void 0) === "";
  }
  _outlineUrl() {
    const e = this._resolved;
    return ie(h(e.fontFamily) ? e.fontFamily : f, e.fontWeight ?? v, e.fontStyle ?? x).outlineUrl;
  }
  _bodyInset(e) {
    return Math.min(Lr, 0.02 * e);
  }
  _refreshBody() {
    if (this._detached) return Promise.resolve();
    const { key: e, input: t } = this._bodyInput();
    return this._body?.setColor(this._bodyColor()), e === this._bodyKey || (this._bodyKey = e, !t && !this._body) ? Promise.resolve() : (this._body ??= new ke(this.scene, this.sceneObject.name), this._body.setParent(this._getParentNode()), this._body.setColor(this._bodyColor()), this._bodyFailed = !1, this._body.update(t).then((r) => {
      !r && this._bodyKey === e && (this._bodyFailed = !0);
    }));
  }
  _thickness() {
    const e = this._depthEm();
    if (e <= 0 || !this._outlineUrl()) return 0;
    const t = $(d(this._resolved.fontSize, 14));
    return e * t + this._bodyInset(t);
  }
  isExtruded() {
    return this._thickness() > 0;
  }
  async buildBody() {
    return this._bodyFailed && (this._bodyKey = null), await this._refreshBody(), this._body ? this._body.built() : null;
  }
  _maxWidthUnits(e, t, r) {
    return $e(e, t, r, this._resolved.wrap);
  }
  _wrapEpsilonUnits(e, t) {
    return Te(e, t);
  }
  _publishMeasurement() {
    const e = {
      ...this._measureContentBox(),
      thickness: this._thickness()
    }, t = this._layoutMeasure;
    this._layoutMeasure = e, (!t || Math.abs(t.width - e.width) > 1e-6 || Math.abs(t.height - e.height) > 1e-6 || Math.abs(t.centerX - e.centerX) > 1e-6 || Math.abs(t.centerY - e.centerY) > 1e-6 || Math.abs(t.layoutCenterX - e.layoutCenterX) > 1e-6 || Math.abs(t.thickness - e.thickness) > 1e-6) && P(this.sceneObject);
  }
  layoutContentFrame = "node";
  getLayoutContentSize() {
    const e = this._measureContentBox();
    return {
      x: e.width,
      y: e.height,
      z: this._thickness()
    };
  }
  getLayoutContentSizeForWidth(e) {
    const t = this._measureContentBox(e);
    return {
      x: t.width,
      y: t.height,
      z: this._thickness()
    };
  }
  setLayoutResolvedWidth(e, t = e) {
    const r = e != null && e > 0 ? e : null, s = t != null && t > 0 ? t : null;
    if (!(r === this._layoutWrapWidth && s === this._layoutSlotWidth)) {
      if (this._layoutWrapWidth = r, this._layoutSlotWidth = s, this._refreshBody(), this._resolved.wrap === !1) {
        this._publishMeasurement();
        return;
      }
      this.textRenderer && this.fontAsset ? this.updateTextContent() : this._publishMeasurement();
    }
  }
  serialize() {
    const e = super.serialize();
    return delete e.bakedWrapWidth, this._resolved.wrap !== !1 && this._layoutWrapWidth != null && Number.isFinite(this._layoutWrapWidth) && (e.bakedWrapWidth = this._layoutWrapWidth), e;
  }
  getLayoutContentCenter() {
    const e = this._measureContentBox();
    return {
      x: e.layoutCenterX,
      y: e.centerY
    };
  }
  _deriveParagraphParams() {
    const e = this._resolved, t = d(e.fontSize, 14), r = d(e.lineHeight, 1.2), s = d(e.letterSpacing, 0), n = e.anchorX ?? "center", o = e.anchorY ?? "middle", i = this._getCommonLineHeightFontUnits(), a = Ce(r, this._metrics, i);
    return {
      scale: $(t),
      anchorY: o,
      rendererLineHeight: a,
      layoutParams: {
        lineHeightUnits: i * a,
        letterSpacingUnits: Fe(s, this._metrics),
        anchorXFraction: Le(n),
        maxWidthUnits: this._maxWidthUnits(this._layoutWrapWidth, this._metrics.emSize, $(t)),
        wrapEpsilonUnits: this._wrapEpsilonUnits(this._metrics.emSize, $(t))
      }
    };
  }
  _fontApi() {
    const e = this.fontAsset;
    return {
      getChar: (t) => e._getChar(t),
      getKerning: (t, r) => e._getKerning(t, r)
    };
  }
  _placeSelectionMesh() {
    const e = this._getParentNode(), t = this.textRenderer ? this._measureContentBox() : null;
    if (!t || t.width <= 0 || t.height <= 0 || !e) {
      this._selectionMesh?.setEnabled(!1);
      return;
    }
    (!this._selectionMesh || this._selectionMesh.isDisposed()) && (this._selectionMesh = Oe.CreateBox(`${this.sceneObject.name}${xe}`, { size: 1 }, this.sceneObject.babylonScene), this._selectionMesh.visibility = 0, this._selectionMesh.isPickable = !0), this._selectionMesh.rotationQuaternion = null, this._selectionMesh.rotation.set(0, 0, 0), this._selectionMesh.scaling.set(t.width, t.height, t.height * 0.1), this._selectionMesh.position.set(t.centerX, t.centerY, 0), this._selectionMesh.parent = e, this._selectionMesh.setEnabled(!0);
  }
  _disposeSelectionMesh() {
    this._selectionMesh && (this._selectionMesh.dispose(), this._selectionMesh = null);
  }
  async _whenAtlasReady(e, t) {
    const r = () => e.textures.every((n) => n.isReady());
    if (r()) return;
    const s = performance.now() + $r;
    for (; !t() && !r() && performance.now() < s; ) await new Promise((n) => setTimeout(n, 16));
  }
  disposeTextRenderer() {
    this._loadGeneration++, this._releaseRenderer();
  }
  _releaseRenderer() {
    this._appliedParagraph = null, this._disposeSelectionMesh(), Sr(this.scene, this), this.renderObserver && this.scene && (this.scene.onAfterCameraRenderObservable.remove(this.renderObserver), this.renderObserver = null), this.textRenderer && (this.textRenderer.dispose(), this.textRenderer = null), this.fontAsset && (this.fontAsset.dispose(), this.fontAsset = null);
  }
  _getParentNode() {
    return this.sceneObject.animationRoot || this.attachedNode;
  }
  async applyCommit(e, t) {
    this._publishMeasurement(), this._refreshBody();
    const r = ce(this._resolved);
    if (r !== this._loadedFontKey) {
      this._loadedFontKey = r, await this.load();
      return;
    }
    this.textRenderer && (this.applyTextProperties(), this._paragraphStateChanged() && this._resetAndRebuild());
  }
  onCommitRolledBack() {
    this._publishMeasurement(), this._loadedFontKey = void 0;
  }
  _paragraphStateChanged() {
    return this._appliedParagraph ? Tr.some((e) => this._resolved[e] !== this._appliedParagraph[e]) : !0;
  }
  _resetAndRebuild() {
    if (!this.textRenderer || !this.fontAsset) return;
    const e = this.textRenderer;
    e._charMatrices.length = 0, e._charUvs.length = 0, e._baseLine = this.fontAsset._font.common.lineHeight * this.fontAsset.scale, e._isDirty = !0, this.updateTextContent();
  }
  validate(e) {
    const t = [];
    return e.fontSize !== void 0 && e.fontSize <= 0 && t.push({
      field: "fontSize",
      message: "Font size must be positive"
    }), e.strokeWidth !== void 0 && (e.strokeWidth < 0 || e.strokeWidth > 0.05) && t.push({
      field: "strokeWidth",
      message: "Stroke width must be between 0 and 0.05 (em)"
    }), e.lineHeight !== void 0 && e.lineHeight <= 0 && t.push({
      field: "lineHeight",
      message: "Line height must be positive"
    }), typeof e.opacity == "number" && !(e.opacity >= 0 && e.opacity <= 1) && t.push({
      field: "opacity",
      message: "Opacity must be between 0 and 1"
    }), typeof e.depth == "number" && !(e.depth >= 0 && e.depth <= 1) && t.push({
      field: "depth",
      message: "Depth must be between 0 and 1 (em)"
    }), t;
  }
  setText(e) {
    const t = this.getData();
    t.text = e, this.commit(t);
  }
  getText() {
    return this._resolved.text ?? "Text";
  }
  getTextRenderer() {
    return this.textRenderer;
  }
  renderGlyphs(e, t) {
    this.textRenderer && this.textRenderer.characterCount > 0 && this.sceneObject.transform.isEnabled() && this.textRenderer.render(e, t);
  }
  isCaptureReady() {
    if (!this.textRenderer || this.textRenderer.characterCount === 0) return !0;
    const e = this.textRenderer._drawWrapperBase?.effect;
    return e ? e.isReady() : !1;
  }
  getSelectionMesh() {
    return this._selectionMesh;
  }
  getEditLayout(e) {
    if (!this.fontAsset) return null;
    const t = e ?? this._resolved.text ?? "Text", { scale: r, anchorY: s, layoutParams: n } = this._deriveParagraphParams(), o = ee(t, n, this._fontApi()), i = re(o, s, this._metrics.capTop), a = 1 / this._metrics.emSize, u = ne(s, i.yTop * a, i.yBot * a, r);
    return Ae(o, a * r, u, this._metrics.emSize);
  }
  getTextRootNode() {
    return this._getParentNode();
  }
}, $r = 1e4;
function ce(e) {
  return `${e.fontFamily ?? f}|${e.fontWeight ?? v}|${e.fontStyle ?? x}`;
}
export {
  zr as _,
  Zr as a,
  sr as b,
  pr as c,
  mr as d,
  es as f,
  Jr as g,
  qr as h,
  Qr as i,
  ge as l,
  Xr as m,
  rs as n,
  C as o,
  gr as p,
  Vr as r,
  ts as s,
  ss as t,
  Gr as u,
  Yr as v,
  Kr as x,
  Dr as y
};

//# sourceMappingURL=text-CeJQaWao.js.map